import React, { useState } from "react";
import { Table, Spin, Pagination, Modal } from "antd";
import moment from "moment";
import { PencilSquareIcon } from "@heroicons/react/16/solid";
import { EyeTwoTone } from "@ant-design/icons";

const customHeaderClass = "!bg-primaryPurple !text-white text-sm !font-bold";

const TaskTable = ({ data, onEdit, loading, tableReFetchData }) => {
  // console.log("task tabledata >>>>>> ", data);

  const [isReviewModalOpen, setIsReviewModalOpen] = useState(false);
  const [selectedReview, setSelectedReview] = useState({
    client: "",
    dev: ""
  });

  const handleViewReview = (record) => {
    // console.log("record ", record);
    setSelectedReview({
      client: record.REMARKS || "",
      dev: record.DEVELOPER_REVIEW || ""
    });
    setIsReviewModalOpen(true);
  };


  const baseColumns = [
    {
      title: "S.NO",
      key: "serialNo",
      align: "center",
      render: (text, record, index) => (
        <span className="text-gray-600 text-sm whitespace-nowrap">
          {index + 1}
        </span>
      ),
    },
    {
      title: "Subject",
      dataIndex: "CLIENTTITLE",
      key: "clientTitle",
      render: (text) => (
        <span className="text-gray-600 text-sm whitespace-nowrap">
          {text || "-"}
        </span>
      ),
    },
    {
      title: "Project title",
      dataIndex: "TITLE",
      key: "taskSubject",
      render: (text) => (
        <span className="text-gray-600 text-sm whitespace-nowrap">
          {text || "-"}
        </span>
      ),
    },
    {
      title: "Assign Date",
      dataIndex: "ASSIGNDATE",
      key: "assignDate",
      render: (date) => {
        if (!date) return "-";
        const formatted = moment(date, [
          "DD-MMM-YYYY hh:mm A",
          "DD-MMM-YYYYhh:mmA",
        ]).format("DD-MMM-YYYY | hh:mm A");
        return (
          <span className="text-gray-600 text-sm whitespace-nowrap">
            {formatted}
          </span>
        );
      },
    },
    {
      title: "Due Date",
      // dataIndex: "DUEDATE",
      dataIndex: "DUE_DATE",
      key: "dueDate",
      render: (date) => {
        if (!date)
          return (
            <span className="text-gray-600 text-sm whitespace-nowrap text-center">
              No due date assigned
            </span>
          );
        const formatted = moment(date, [
          "DD-MMM-YYYY hh:mm A",
          "DD-MMM-YYYYhh:mmA",
        ]).format("DD-MMM-YYYY | hh:mm A");
        return (
          <span className="text-gray-600 text-sm whitespace-nowrap">
            {formatted}
          </span>
        );
      },
    },
    {
      title: "Complain Date",
      dataIndex: "COMPLAINDATE",
      key: "complainDate",
      width: 120,
      render: (date) => (
        <span className="text-gray-600 text-sm whitespace-nowrap">
          {date ? moment(date).format("DD-MMM-YYYY") : "-"}
        </span>
      ),
    },
    {
      title: "Complain By",
      dataIndex: "COMPLAINBY",
      key: "complainBy",
      render: (text) => (
        <span className="text-gray-600 text-sm whitespace-nowrap">
          {text || "-"}
        </span>
      ),
    },
    {
      title: "Assigned Staff",
      dataIndex: "EMPLOYEE_NAMES",
      key: "assignedStaff",
      render: (text) => (
        <span className="text-gray-600 text-sm whitespace-nowrap">
          {text || "-"}
        </span>
      ),
    },
    {
      title: "Priority",
      dataIndex: "PRIORITY_TITLE",
      key: "priority",
      render: (text) => (
        <span className="text-gray-600 text-sm whitespace-nowrap">
          {text || "-"}
        </span>
      ),
    },
    {
      title: "Status",
      dataIndex: "STATUS",
      key: "status",
      render: (text) => (
        <span className="text-gray-600 text-sm whitespace-nowrap">
          {text || "-"}
        </span>
      ),
    },
    {
      title: "Feature",
      dataIndex: "WORK_TYPE",
      key: "workType",
      render: (text) => (
        <span className="text-gray-600 text-sm whitespace-nowrap">
          {text || "-"}
        </span>
      ),
    },
    {
      title: "Approved By",
      dataIndex: "APPROVEBY",
      key: "approveBy",
      render: (text) => (
        <span className="text-gray-600 text-sm whitespace-nowrap">
          {text || "-"}
        </span>
      ),
    },
    {
      title: "Approved Date",
      dataIndex: "APPROVEDATE",
      key: "approveDate",
      render: (date) => (
        <span className="text-gray-600 text-sm whitespace-nowrap">
          {date ? moment(date).format("DD-MMM-YYYY") : "-"}
        </span>
      ),
    },
    {
      title: "Complete Date",
      dataIndex: "COMPLETEDATE",
      key: "completeDate",
      render: (date) => (
        // setCompleteDate(date)
        <span className="text-gray-600 text-sm whitespace-nowrap">
          {date ? moment(date).format("DD-MMM-YYYY | hh:mm A") : "-"}
        </span>
      ),
    },
    {
      title: "Days Taken",
      dataIndex: "COMPLETE_DURATION_DAYS",
      key: "completeDate",
      render: (date) => (
        <span className="text-gray-600 text-sm whitespace-nowrap">
          {date}
        </span>
      ),
    },
    {
      title: "Last Update",
      dataIndex: "LASTUPDATE",
      key: "lastUpdate",
      render: (date) => (
        <span className="text-gray-600 text-sm whitespace-nowrap">
          {date ? moment(date).format("DD-MMM-YYYY hh:mm A") : "-"}
        </span>
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => {
        // console.log(record)
        return (
          <div className="flex gap-2">
            <button
              onClick={() => onEdit(record)}
              className="hover:scale-110 transition-transform duration-200"
            >
              <PencilSquareIcon className="h-6 w-6 text-blue-500" />
            </button>
            <button
              onClick={() => handleViewReview(record)}
              className="hover:scale-110 transition-transform duration-200"
            >
              <EyeTwoTone twoToneColor="#722ed1" style={{ fontSize: "22px" }} />
            </button>
          </div>
        )
      },
    },
  ];

  const columns = baseColumns.map((col) => ({
    ...col,
    onHeaderCell: () => ({
      className: customHeaderClass,
    }),
  }));



  // console.log(columns, "columns ......");

  return (
    <div>
      {loading ? (
        // skeleton table
        <table className="min-w-full bg-white">
          <thead className="bg-primaryPurple whitespace-nowrap">
            <tr>
              {columns.map((col, index) => (
                <th
                  key={index}
                  className="p-4 text-left text-sm md:text-lg font-bold text-white"
                >
                  {col.title}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {Array(8)
              .fill(0)
              .map((_, rowIndex) => (
                <tr key={rowIndex} className="even:bg-blue-50">
                  {columns.map((_, colIndex) => (
                    <td
                      key={colIndex}
                      className="p-4 border-b border-gray-100 animate-pulse"
                    >
                      <div className="h-4 bg-gray-300 rounded w-full"></div>
                    </td>
                  ))}
                </tr>
              ))}
          </tbody>
        </table>
      ) : (
        <Table
          columns={columns}
          dataSource={data}
          pagination={false}
          locale={{ emptyText: "No Data Available " }}
          scroll={{ x: true }}
          rowKey={(record) => record.ID || record.key || Math.random()}
          style={{
            fontSize: "20px",
            fontWeight: "bolder",
            color: "#000"
          }}
        />
      )}

      <div className="flex justify-end mt-4">
        <Pagination defaultCurrent={1} total={0} showSizeChanger={false} />
      </div>

      <Modal
        title="Task Review Details"
        open={isReviewModalOpen}
        footer={null}
        onCancel={() => setIsReviewModalOpen(false)}
        width={600}
      >
        <div className="space-y-5">
          {/* Client Review */}
          <div className="bg-amber-50 border border-amber-200 rounded-xl p-4">
            <div className="flex items-center gap-2 mb-2">
              <div className="w-2 h-2 bg-amber-500 rounded-full"></div>
              <h3 className="font-semibold text-amber-700">
                Client Review
              </h3>
            </div>
            <p className="text-gray-700 whitespace-pre-line text-sm leading-relaxed">
              {selectedReview.client || (
                <span className="text-gray-400 italic">
                  No client review added
                </span>
              )}
            </p>
          </div>
          {/* Dev Review */}
          <div className="bg-indigo-50 border border-indigo-200 rounded-xl p-4">
            <div className="flex items-center gap-2 mb-2">
              <div className="w-2 h-2 bg-indigo-500 rounded-full"></div>
              <h3 className="font-semibold text-indigo-700">
                Developer Remark
              </h3>
            </div>
            <p className="text-gray-700 whitespace-pre-line text-sm leading-relaxed">
              {selectedReview.dev || (
                <span className="text-gray-400 italic">
                  No developer remark added
                </span>
              )}
            </p>
          </div>
        </div>
      </Modal>

    </div>
  );
};
export default TaskTable;
